import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/legal/LegalLayout";
import { LegalP, LegalSection } from "@/components/legal/LegalProse";
import { OPERATOR } from "@/lib/legal";
import { tw } from "@/lib/theme";

export function FaqPage() {
  return (
    <LegalLayout title="FAQ" subtitle={`Common questions about ${OPERATOR.product}.`}>
      <LegalSection title="What is Daywia?">
        <LegalP>
          A photo-first social app for Frames (posts), Drifts (short video), Parallel (collab
          capture), chat, and creator tips—built for India with contact-based friend discovery.
        </LegalP>
      </LegalSection>

      <LegalSection title="How do I create content?">
        <LegalP>
          Tap the center + button in the app. Choose Frame for photos, Drift for short video, or
          Parallel to capture with a friend in sync.
        </LegalP>
      </LegalSection>

      <LegalSection title="When does my Drift appear in the feed?">
        <LegalP>
          A Drift shows in the feed only after its post status becomes ready—usually right after
          upload finishes processing on our servers.
        </LegalP>
      </LegalSection>

      <LegalSection title="Public vs private profile">
        <LegalP>
          Turn on Public profile in Edit Profile to unlock discovery and creator insights. Turn it
          off for a contact-only space—others connect via synced contacts, not public follow
          discovery.
        </LegalP>
      </LegalSection>

      <LegalSection title="Contact sync">
        <LegalP>
          Optional. We hash phone numbers to suggest friends on Daywia without exposing your
          address book. See our{" "}
          <Link to="/privacy" className={tw.link}>
            Privacy Policy
          </Link>
          .
        </LegalP>
      </LegalSection>

      <LegalSection title="Sparks & invites">
        <LegalP>
          Earn Sparks when invited friends sign up (monthly limits apply). Sparks are rewards, not
          cash—see{" "}
          <Link to="/payments" className={tw.link}>
            Payments
          </Link>
          .
        </LegalP>
      </LegalSection>

      <LegalSection title="Delete my account">
        <LegalP>
          Settings → FAQ → Delete account in the Android app. Details on{" "}
          <Link to="/data-deletion" className={tw.link}>
            Data deletion
          </Link>
          .
        </LegalP>
      </LegalSection>

      <LegalSection title="Still need help?">
        <LegalP>
          <Link to="/contact" className={tw.link}>
            Contact support
          </Link>{" "}
          — we typically reply within one business day.
        </LegalP>
      </LegalSection>
    </LegalLayout>
  );
}
